import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getYouTubeVideoId } from '../lib/getYouTubeVideoId';
import PDFViewer from './PDFView';

// Modern, attractive icons
const JournalsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"></path>
    <line x1="8" y1="7" x2="15" y2="7"></line>
    <line x1="8" y1="11" x2="15" y2="11"></line>
    <line x1="8" y1="15" x2="12" y2="15"></line>
  </svg>
);

const BookHalfIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
  </svg>
);

const ChatLeftDotsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
    <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z"></path>
    <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"></path>
  </svg>
);

const ClipboardCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
    <path d="M8 3v3a2 2 0 0 1-2 2H3"></path>
    <path d="M21 8v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6"></path>
    <path d="m9 14 2 2 4-4"></path>
  </svg>
);

const TestIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <circle cx="10" cy="10" r="1"></circle>
    <circle cx="10" cy="14" r="1"></circle>
    <circle cx="10" cy="18" r="1"></circle>
    <path d="M14 10h4"></path>
    <path d="M14 14h4"></path>
    <path d="M14 18h4"></path>
  </svg>
);

const MoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
    <circle cx="12" cy="6" r="1"></circle>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="18" r="1"></circle>
  </svg>
);

const FullscreenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <polyline points="15 3 21 3 21 9"></polyline>
    <polyline points="9 21 3 21 3 15"></polyline>
    <line x1="21" y1="3" x2="14" y2="10"></line>
    <line x1="3" y1="21" x2="10" y2="14"></line>
  </svg>
);

const MinimizeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <polyline points="4 14 10 14 10 20"></polyline>
    <polyline points="20 10 14 10 14 4"></polyline>
    <line x1="14" y1="10" x2="21" y2="3"></line>
    <line x1="3" y1="21" x2="10" y2="14"></line>
  </svg>
);

const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
  </svg>
);

interface User {
  first_name: string;
  last_name: string;
}

interface Teacher {
  user: User;
}

interface Lecture {
  id: number;
  topic: string;
  description: string;
  is_unlocked: boolean;
  yt_link_ref: string;
  cnotes_ref: string | null;
  notes_ref: string | null;
  dpp_ref: string | null;
  is_locked: boolean;
  chapter: number;
  created_by: Teacher;
}

const LectureDisplay: React.FC<{ lecture: Lecture }> = ({ lecture }) => {
  const videoId = lecture.yt_link_ref ? getYouTubeVideoId(lecture.yt_link_ref) : 'm49xicAem6E';
  const iframeContainerRef = useRef<HTMLDivElement>(null);
  
  // Extract filename and handle URL modifications
  const extractFileName = (filePath: string | null): string => {
    if (!filePath) return '';
    
    let modifiedPath = filePath;
    if (filePath.includes('https://naendapi.naecoaching.com')) {
      modifiedPath = filePath.replace('https://naendapi.naecoaching.com', '');
    }
    
    return modifiedPath.replace('/media/', '').replace('.pdf', '');
  };

  // Prepare modified paths for all resource types
  const cnotes_ref_modified = extractFileName(lecture.cnotes_ref);
  const notes_ref_modified = extractFileName(lecture.notes_ref);
  const dpp_ref_modified = extractFileName(lecture.dpp_ref);

  const [url, setUrl] = useState('');
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showVideo, setShowVideo] = useState(true);
  const [activeTab, setActiveTab] = useState('notes');
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (videoId) {
      setUrl(`https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1&showinfo=0&autohide=1&controls=1`);
    } else {
      setUrl("https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=0&rel=0&modestbranding=1&showinfo=0&autohide=1&controls=1");
    }
  }, [videoId]);

  const handleFullscreen = () => {
    if (iframeContainerRef.current) {
      if (iframeContainerRef.current.requestFullscreen) {
        iframeContainerRef.current.requestFullscreen();
      } else if ((iframeContainerRef.current as any).webkitRequestFullscreen) {
        (iframeContainerRef.current as any).webkitRequestFullscreen();
      } else if ((iframeContainerRef.current as any).msRequestFullscreen) {
        (iframeContainerRef.current as any).msRequestFullscreen();
      }
      setIsFullscreen(true);
    }
  };
  
  const handleExitFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      setIsFullscreen(false);
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
      setIsFullscreen(false);
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
      setIsFullscreen(false);
    }
  };

  const playVideo = () => {
    setIsPlaying(true);
    setUrl(`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&showinfo=0&autohide=1&controls=1`);
  };

  // Dynamic background based on chapter number for visual variety
  const bgColors = [
    'from-blue-500 to-purple-600',
    'from-green-400 to-cyan-500',
    'from-pink-500 to-rose-500',
    'from-amber-500 to-orange-600',
    'from-indigo-500 to-violet-500'
  ];
  const bgColor = bgColors[lecture.chapter % bgColors.length];
  
  return (
    <div className="flex flex-col h-full bg-gray-50">
      {/* Video Player Section with Gradient Background */}
      <div className={`w-full sticky top-0 z-10 bg-gradient-to-r ${bgColor} shadow-lg`}>
        <div className="container mx-auto pt-4 pb-6 px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-4 text-white">
            <div>
              <h2 className="text-2xl font-bold">{lecture.topic}</h2>
              <p className="text-sm opacity-90 mt-1">{lecture.description}</p>
            </div>
            <div className="flex items-center mt-2 md:mt-0">
              <div className="bg-white bg-opacity-20 backdrop-blur-sm text-white text-xs font-medium px-3 py-1 rounded-full mr-3">
                Chapter {lecture.chapter}
              </div>
              <div className="text-xs text-white">
                {lecture.created_by?.user?.first_name} {lecture.created_by?.user?.last_name}
              </div>
            </div>
          </div>

          <div className="rounded-xl overflow-hidden shadow-2xl bg-black">
            <div
              ref={iframeContainerRef} 
              className="w-full h-0 relative"
              style={{ paddingBottom: '56.25%' }}
            >
              {!isPlaying && (
                <div 
                  className="absolute inset-0 flex items-center justify-center bg-black z-10 cursor-pointer"
                  onClick={playVideo}
                >
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-50"></div>
                  <img 
                    src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`} 
                    alt="Video thumbnail" 
                    className="absolute inset-0 w-full h-full object-cover opacity-70"
                  />
                  <div className="relative z-20 flex flex-col items-center">
                    <div className="text-white bg-red-600 rounded-full p-2 mb-2 transform transition-transform hover:scale-110">
                      <PlayIcon />
                    </div>
                    <span className="text-white font-medium text-sm">Play Video</span>
                  </div>
                </div>
              )}
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src={url}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ display: isPlaying ? 'block' : 'none' }}
              ></iframe>

              {isPlaying && (
                <div className="absolute bottom-4 right-4 flex gap-2">
                  {isFullscreen ? (
                    <button
                      onClick={handleExitFullscreen}
                      className="bg-white bg-opacity-20 backdrop-blur-sm text-white p-2 rounded-full shadow-lg hover:bg-opacity-30 transition-all duration-300"
                      title="Exit fullscreen"
                    >
                      <MinimizeIcon />
                    </button>
                  ) : (
                    <button
                      onClick={handleFullscreen}
                      className="bg-white bg-opacity-20 backdrop-blur-sm text-white p-2 rounded-full shadow-lg hover:bg-opacity-30 transition-all duration-300"
                      title="Enter fullscreen"
                    >
                      <FullscreenIcon />
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-md border-b z-[5]">
        <div className="container mx-auto">
          <div className="flex overflow-x-auto scrollbar-hide">
            <button 
              onClick={() => setActiveTab('notes')}
              className={`flex-shrink-0 py-4 px-6 font-medium text-sm transition-all duration-200 ${activeTab === 'notes' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Class Notes
            </button>
            <button 
              onClick={() => setActiveTab('studyNotes')}
              className={`flex-shrink-0 py-4 px-6 font-medium text-sm transition-all duration-200 ${activeTab === 'studyNotes' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Study Notes
            </button>
            <button 
              onClick={() => setActiveTab('dpp')}
              className={`flex-shrink-0 py-4 px-6 font-medium text-sm transition-all duration-200 ${activeTab === 'dpp' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Daily Practice
            </button>
            <button 
              onClick={() => setActiveTab('quiz')}
              className={`flex-shrink-0 py-4 px-6 font-medium text-sm transition-all duration-200 ${activeTab === 'quiz' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Quiz
            </button>
            <button 
              onClick={() => setActiveTab('doubts')}
              className={`flex-shrink-0 py-4 px-6 font-medium text-sm transition-all duration-200 ${activeTab === 'doubts' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Ask Doubts
            </button>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-grow overflow-y-auto container mx-auto px-4 pb-4">
        {activeTab === 'notes' && (
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-4 flex items-center justify-between border-b">
              <div className="flex items-center">
                <div className="w-6 h-6 text-red-600 mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-800">Class Notes PDF</h3>
              </div>
              <button className="flex items-center gap-1 text-xs font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors">
                <DownloadIcon />
                <span>Download</span>
              </button>
            </div>
            {lecture.cnotes_ref && (
              
            <PDFViewer pdfUrl= {lecture.cnotes_ref} subPath="cnotes" title="Annual Report" />

            )}
            {/* PDFViewer component to display the PDF */}
            {/* <PDFViewer 
              pdfUrl={lecture.cnotes_ref ? `http://localhost/media/cnotes/${lecture.cnotes_ref}.pdf` : ''} 
              title={`${lecture.cnotes_ref ? lecture.cnotes_ref : 'No PDF Available'}.pdf`}
            /> */}
          </div>
        )}

        {activeTab === 'studyNotes' && (
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-4 flex items-center justify-between border-b">
              <div className="flex items-center">
                <div className="w-6 h-6 text-green-600 mr-2">
                  <BookHalfIcon />
                </div>
                <h3 className="text-lg font-medium text-gray-800">Study Notes PDF</h3>
              </div>
              <button className="flex items-center gap-1 text-xs font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors">
                <DownloadIcon />
                <span>Download</span>
              </button>
            </div>
            {lecture.notes_ref && (
              
              <PDFViewer pdfUrl= {lecture.notes_ref} subPath="xnotes" title="Annual Report" />
  
              )}
          </div>
        )}

        {activeTab === 'dpp' && (
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-4 flex items-center justify-between border-b">
              <div className="flex items-center">
                <div className="w-6 h-6 text-red-600 mr-2">
                  <ClipboardCheckIcon />
                </div>
                <h3 className="text-lg font-medium text-gray-800">Daily Practice Problems</h3>
              </div>
              <button className="flex items-center gap-1 text-xs font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors">
                <DownloadIcon />
                <span>Download</span>
              </button>
            </div>
            {lecture.dpp_ref && (
              
              <PDFViewer pdfUrl= {lecture.dpp_ref} subPath="cnotes" title="Annual Report" />
  
              )}
          </div>
        )}

        {activeTab === 'quiz' && (
          <div className="bg-white rounded-xl shadow-md p-8 text-center">
            <div className="w-16 h-16 mx-auto mb-4 text-amber-500">
              <TestIcon />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Test Your Knowledge</h3>
            <p className="text-gray-600 mb-6">Ready to check what you've learned from this lecture?</p>
            <Link 
              to={`/QuizPage/?type=lecture&id=${lecture.id}`}
              className="inline-block px-6 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all"
            >
              Start Quiz
            </Link>
          </div>
        )}

        {activeTab === 'doubts' && (
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 mx-auto mb-4 text-purple-600">
                <ChatLeftDotsIcon />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Ask Your Doubts</h3>
              <p className="text-gray-600">Our instructors are here to help you understand the concepts better.</p>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Your Question</label>
              <textarea 
                className="w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 p-3 h-32"
                placeholder="Type your question here..."
              ></textarea>
            </div>
            
            <button className="w-full py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all">
              Submit Question
            </button>
          </div>
        )}
      </div>

      {/* Quick Access Buttons */}
      <div className="container mx-auto px-4 mt-4">
        <div className="flex justify-center flex-wrap gap-3 md:gap-6 mb-4 pb-20">
          <Link 
            to={lecture.cnotes_ref ? `/pdf/${cnotes_ref_modified}` : '/pdf'} 
            className="flex flex-col items-center justify-center bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 w-16 md:w-20"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 text-blue-600 mb-2">
              <JournalsIcon />
            </div>
            <p className="text-[10px] md:text-xs font-medium text-gray-700">Notes</p>
          </Link>
          
          <Link 
            to={lecture.notes_ref ? `/pdf/${notes_ref_modified}` : '/pdf'} 
            className="flex flex-col items-center justify-center bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 w-16 md:w-20"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 text-green-600 mb-2">
              <BookHalfIcon />
            </div>
            <p className="text-[10px] md:text-xs font-medium text-gray-700">Study</p>
          </Link>
          
          <div
            // to={lecture.cnotes_ref ? `/pdf/${cnotes_ref_modified}` : '/pdf'} 
            onClick={() => setActiveTab('doubts')}
            className="flex flex-col items-center justify-center bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 w-16 md:w-20"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 text-purple-600 mb-2">
              <ChatLeftDotsIcon />
            </div>
            <p className="text-[10px] md:text-xs font-medium text-gray-700">Doubts</p>
          </div>
          
          <Link 
            to={lecture.dpp_ref ? `/pdf/${dpp_ref_modified}` : '/pdf'} 
            className="flex flex-col items-center justify-center bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 w-16 md:w-20"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 text-red-600 mb-2">
              <ClipboardCheckIcon />
            </div>
            <p className="text-[10px] md:text-xs font-medium text-gray-700">Practice</p>
          </Link>
          
          <Link 
            to={`/QuizPage/?type=lecture&id=${lecture.id}`} 
            className="flex flex-col items-center justify-center bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 w-16 md:w-20"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 text-amber-600 mb-2">
              <TestIcon />
            </div>
            <p className="text-[10px] md:text-xs font-medium text-gray-700">Quiz</p>
          </Link>
        </div>
      </div>

      {/* Floating Action Button */}
      <div className="fixed bottom-6 right-6">
        <button className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </button>
      </div>
    </div>
  );
};

const LecturePage: React.FC = () => {
  const location = useLocation();
  const lecture = location.state as Lecture;

  if (!lecture) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center p-8 bg-white rounded-xl shadow-md max-w-md">
          <div className="w-20 h-20 mx-auto mb-4 text-red-500">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Lecture Not Found</h2>
          <p className="text-gray-600 mb-6">We couldn't find the lecture you're looking for. It may have been moved or deleted.</p>
          <Link to="/" className="inline-block px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all">
            Back to Course
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <LectureDisplay key={lecture.id} lecture={lecture} />
    </div>
  );
};

export default LecturePage;